import { EnumValue } from 'aos-helpers/src/helpers/Enum'
import { TaskFormPayload } from 'aos-services/src/services/tasks/types/payload/TaskFormPayload'
import { TaskCategory } from 'aos-services/src/services/tasks/types/TaskCategory'
import {
    TaskStatus,
    taskStatuses,
    translateTaskTitle,
} from 'aos-services/src/services/tasks/types/TaskStatus'
import { Input, InputField, StatusDropdown } from 'aos-ui-universal'
import React from 'react'
import { Controller, useController, useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { TaskOrTemplatePayload } from '../../../utils'
import { TaskFormField } from '../TaskFormField'

interface TaskStatusFieldProps {
    statusReadOnly?: boolean
}

export const TaskStatusField = ({ statusReadOnly }: TaskStatusFieldProps) => {
    const { t: translate } = useTranslation()
    const { control } = useFormContext<TaskOrTemplatePayload>()
    const task = useWatch({ control }) as TaskFormPayload
    const recurrenceField = useController({ control, name: 'recurrence' })

    if (statusReadOnly) {
        return (
            <TaskFormField label={translate('form.status.label', { ns: 'tasks' })}>
                <Input>
                    <InputField
                        editable={false}
                        value={translateTaskTitle(translate)(task.status as EnumValue)}
                    />
                </Input>
            </TaskFormField>
        )
    }

    return (
        <Controller
            control={control}
            name='status'
            render={({ field, fieldState }) => (
                <TaskFormField
                    label={translate('form.status.label', { ns: 'tasks' })}
                    required
                    error={
                        fieldState.error
                            ? translate('form.status.error', { ns: 'tasks' })
                            : undefined
                    }
                >
                    <StatusDropdown
                        size='md'
                        value={field.value ?? ''}
                        options={taskStatuses
                            .filter(s =>
                                task.category === TaskCategory.LVP ? s !== TaskStatus.OnHold : true,
                            )
                            .map(s => ({
                                value: s,
                                label: translateTaskTitle(translate)(s),
                            }))}
                        onChange={value => {
                            const status = value as TaskStatus
                            field.onChange(status)
                            if (status === TaskStatus.Done) {
                                recurrenceField.field.onChange(undefined)
                            }
                        }}
                    />
                </TaskFormField>
            )}
        />
    )
}
